import { Paper, Stack, Typography } from '@mui/material';
import type { Theme } from '@mui/material/styles';
import type { SxProps } from '@mui/material';
import React from 'react';

export type VyRadioCardProps = {
  title: string;
  description: string;
  icon?: React.ReactNode;
  iconBackgroundColor?: string;
  selected: boolean;
  onClick: () => void;
  titleSx?: SxProps<Theme>;
  descriptionSx?: SxProps<Theme>;
};

export const VyRadioCard: React.FC<VyRadioCardProps> = ({
  title,
  description,
  icon,
  iconBackgroundColor = '#B0D2FF',
  selected,
  onClick,
  titleSx,
  descriptionSx,
}) => {
  return (
    <Paper
      elevation={0}
      sx={{
        flex: 1,
        padding: 3,
        border: selected ? '1px solid #5EA3EF' : '1px solid #E8EBF2',
        borderRadius: '8px',
        cursor: 'pointer',
        backgroundColor: selected ? '#E7F2FF' : 'white',
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
          borderColor: '#5EA3EF',
          backgroundColor: '#E7F2FF',
        },
      }}
      onClick={onClick}
    >
      <Stack
        spacing={2}
        sx={{
          alignItems: "center",
          textAlign: "center"
        }}>
        {icon && (
          <Stack
            sx={{
              width: 48,
              height: 48,
              borderRadius: '50%',
              backgroundColor: iconBackgroundColor,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {icon}
          </Stack>
        )}
        <Stack
          spacing={0.5}
          sx={{
            alignItems: 'center',
            textAlign: 'center',
          }}
        >
          <Typography
            variant="h6"
            sx={[{ fontFamily: 'Inter, sans-serif', fontWeight: 400 }, ...(Array.isArray(titleSx) ? titleSx : [titleSx])]}
          >
            {title}
          </Typography>
          <Typography variant="body2" sx={[{ color: 'text.secondary', lineHeight: 1.5 }, ...(Array.isArray(descriptionSx) ? descriptionSx : [descriptionSx])]}>
            {description}
          </Typography>
        </Stack>
      </Stack>
    </Paper>
  );
};
